<!--  收付申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        收付申请
        <small>结费任务收付申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 收付申请
          </a>
        </li>
        <li class="active">收付申请</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div id="atptoolbar"></div>

      <!--  申请表单  -->
      <div class="apply-form">

        <div class="form-group overflow-hidden">
          <label class="control-sidebar-subheading col-sm-4">
            请选择基站
            <select class="form-control" v-model="selectedStationID" @change="chooseStation(selectedStationID)">
              <option v-for="(item,index) in stationList" :key="index" :value="item.stst_atpid">
                {{item.stst_commname}}
              </option>
            </select>
          </label>
        </div>

        <div class="pay-task-list-panel">

          <div v-for="(taskItem,index) in payTaskList" :key="index" class="pay-task-item">
            <!--  信息展示区  -->
            <div class="pay-task-info">
              <div>
                (ID:{{taskItem.id || '新增'}}) 应结费金额 : {{taskItem.money}}
              </div>
              <div class="can_pay_time">
                可结费时间 : {{taskItem.can_pay_time}}
              </div>
              <div class="pay_at">
                实际结费时间 : {{taskItem.pay_at}}
              </div>
              <div class="remark">
                备注 : {{taskItem.remark}}
              </div>
            </div>
            <!--  申请按钮  -->
            <div class="pay-task-right">
              <div class="type">
                <span v-if="taskItem.type == 1">业主租金</span>
                <span v-if="taskItem.type == 2">局方地租金</span>
                <span v-if="taskItem.type == 3">局方杆租金</span>
                <span v-if="taskItem.type == 4">业务协调费</span>
                <span v-if="taskItem.type == 5">平台签约奖励</span>
                <span v-if="taskItem.type == 6">杆塔资源费</span>
                <span v-if="taskItem.type == 7">商务提成</span>
              </div>

              <div class="remove-button">
                <button v-if="taskItem.pay_at" class="btn btn-default" disabled>
                  已结清
                </button>
                <button v-else class="btn btn-info" type="button" id="sys_remove" @click="pay_task_apply(index)">
                  申请
                </button>
              </div>
            </div>

          </div>

        </div>

      </div>

    </section>

    <v-applypaytaskpaymentmodal ref="applyPayTaskPaymentModal"></v-applypaytaskpaymentmodal>

  </div>
</template>

<script>

import {datepicker} from 'eonasdan-bootstrap-datetimepicker'
import applyPayTaskPaymentModal from './applyPayTaskPaymentModal'

export default {
  name: 'applyPayTaskPayment',
  data() {
    return {
      stationList: [], // 基站列表
      selectedStationID: null, // 当前选中基站ID
      payTaskList: [], // 结费任务列表
      form: {} // 申请表单
    }
  },

  components: {
    datepicker,
    'v-applypaytaskpaymentmodal': applyPayTaskPaymentModal
  },

  mounted: function () {
    let self = this
    let org_id = JSON.parse(localStorage.getItem('companyInfo')).id
    self.org_id = org_id
    console.log('___页面挂载成功,org_id:', org_id)

    // 获取公司下基站列表
    self.global.axiosGet(self, `stations/?org_id=${org_id}&per_page=999999`, function (res) {
      console.log('___获取到基站列表', res)
      self.stationList = res.rows
    })
  },

  methods: {
    chooseStation: function (value) {
      let self = this
      console.log('___切换基站', value, '开始获取基站结费任务')
      self.global.axiosGet(self, `pay_tasks/?station_id=${value}&per_page=999999`, function (res) {
        console.log('___获取到基站结费任务信息', res, '数据', res.rows)
        self.payTaskList = res.rows
      })
    },

    pay_task_apply: function (index) {
      let self = this
      let payTaskList = JSON.parse(JSON.stringify(this.payTaskList))

      // 基站信息
      let station = {}
      let stationList = JSON.parse(JSON.stringify(this.stationList))
      stationList.map(item => {
        if (item.stst_atpid === self.selectedStationID)
          station = item
      })

      setTimeout(function () {
        console.log('___pay_task_apply,申请', payTaskList[index])
        self.$refs.applyPayTaskPaymentModal.initFunc(payTaskList[index], station) // 调用子组件函数
      }, 1000)
    },

    datePicker: function (elementId) {
      let self = this
      WdatePicker({
        el: elementId,
        dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
        onpicked: function () {
          var value = $('#' + elementId).val()
          console.log('___日期elementId', elementId, value)
          // var timeStamp = self.global.timeToStamp(value)
          self.form[elementId] = value
        },
        oncleared: function () {
          self[elementId] = null
        },
        isShowClear: true,
        readOnly: true
      })
    }

  }

}
</script>

<style scoped>

  .overflow-hidden {
    overflow: hidden
  }

  .pay-task-list-panel {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .pay-task-item {
    width: 60%;
    height: 100px;
    margin: 10px auto 0 auto;
    border-radius: 10px;
    background-color: #C4C4C4;
    display: flex;
  }

  .pay-task-info {
    width: 60%;
    font-size: 18px;
    padding: 5px 0 0 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    text-align: left;
  }

  .pay-task-info .can_pay_time, .pay_at {
    font-size: 15px;
  }

  .pay-task-info .remark {
    font-size: 15px;
    color: gray;
  }

  .pay-task-right {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 40%;
    padding: 5px 0 0 0;
    text-align: right;
  }

  .pay-task-right .type {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyPayTaskPayment.vue